import React from 'react'
import { SINGLE_FORM_TEMPLATE, DETAILS, BRANCH, TYPE_OF_REQUEST } from '../../helpers/constants'

const LoadingForm = () => {
  const fieldItems = SINGLE_FORM_TEMPLATE.map(key => {
    const fieldType = key === DETAILS ? 'textarea' : [BRANCH, TYPE_OF_REQUEST].includes(key) ? 'button-group' : 'input'
    return <div key={key}>
      <div className='nft-skeleton nft-skeleton__label loading-animation' />
      <div className={`nft-skeleton nft-skeleton__field ${fieldType !== 'button-group' ? 'loading-animation' : ''} nft-skeleton--${fieldType}`}>
        {fieldType === 'button-group' && [1, 2, 3].map(item => <div key={item} className='nft-skeleton__btn loading-animation' />)}
      </div>
    </div>
  })
  return <div className='nft-skeleton__container'>
    <div className='nft-skeleton nft-skeleton__title loading-animation' />
    { fieldItems }
    <div className='nft-skeleton nft-skeleton--button loading-animation' />
  </div>
}

export default LoadingForm